import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { Typography, Tooltip } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useSelector } from 'react-redux'
import {
  CourseCreationNonAttachmentView,
  CourseCreationAttachmentView,
  AddSourceModal,
} from '../index'
const SourceDocuments = ({
  classes,
  fileInputRef,
  handleOnDropFile,
  handleFileSelect,
  attachmentLoading,
  documentFollowing,
  onDocumentFollowingChange,
}) => {
  // Get attachments from Redux store
  const [modalOpen, setModalOpen] = React.useState(false)
  const attachments = useSelector(state => state.aICreator.attachments)
  const validAttachments = attachments.filter(
    attachment =>
      attachment.upload_status !== 'partial_failure' &&
      attachment.upload_status !== 'failed' &&
      !(attachment.error_details && attachment.error_details.length > 0),
  )

  return (
    <div className={classes.courseInfo}>
      <div className={classes.courseInfoTitleStart}>
        <span className={classes.sectionLabel}>
          Sources <span className={classes.optional}>(optional)</span>
          <Tooltip
            title={
              <Typography fontSize={12} fontWeight={400}>
                If uploaded, AI will use your resource(s) as the foundation for
                <span style={{ fontWeight: 600 }}> your </span> course content.
              </Typography>
            }
          >
            <span
              style={{
                display: 'inline-flex',
                color: '#919EAB',
                cursor: 'help',
              }}
            >
              <Icon icon="tabler:info-circle" width={14} height={14} />
            </span>
          </Tooltip>
        </span>

        <button
          type="button"
          className={classes.addSource}
          onClick={() => setModalOpen(true)}
        >
          <Icon icon="tabler:plus" width={14} height={14} />
          Add source
        </button>
      </div>

      {validAttachments.length > 0 ? (
        <CourseCreationAttachmentView
          attachments={attachments}
          handleOnDropFile={handleOnDropFile}
          fileInputRef={fileInputRef}
          handleFileSelect={handleFileSelect}
          attachmentLoading={attachmentLoading}
          documentFollowing={documentFollowing}
          onDocumentFollowingChange={onDocumentFollowingChange}
          onAddSource={() => setModalOpen(true)}
        />
      ) : (
        <CourseCreationNonAttachmentView
          fileInputRef={fileInputRef}
          handleOnDropFile={handleOnDropFile}
          handleFileSelect={handleFileSelect}
          attachmentLoading={attachmentLoading}
          documentFollowing={documentFollowing}
          onDocumentFollowingChange={onDocumentFollowingChange}
          onAddSource={() => setModalOpen(true)}
        />
      )}

      <AddSourceModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        fileInputRef={fileInputRef}
        handleFileSelect={handleFileSelect}
        handleOnDropFile={handleOnDropFile}
        attachmentLoading={attachmentLoading}
      />
    </div>
  )
}

export default withStyles(styles)(SourceDocuments)
